import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, IconButton, Switch, Typography } from "@mui/material";
import ResponsiveDialog from "../../../Component/ResponsiveDialog";
import { Link, useSearchParams,useNavigate } from "react-router-dom";
import { masterAPI } from "../dataConfig";
import { axiosPrivate } from "../../../axios/axios";

import {
  ArrowBack,
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import RemedyModal from "./RemedyModal";
import {useDispatch, useSelector} from "react-redux"
import { decode, encode } from "../../../Component/JWT/Formatt";


const Remedy = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const actionsAllow=useSelector(state=>state.dataRed.actionsAllow)

  const navigate=useNavigate()
  const dispatch=useDispatch()
  const problemId=useSelector(state=>state.dataRed.problem)

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [filterValue,setFilterValue]=useState("enableData")
  const [backUpData,setBackUpData]=useState([])

  useEffect(() => {
    getData();
  }, []);

  const getData = async() => {
    setIsLoading(true);
    const link = masterAPI["Remedies"].remdybycause;
    const id=decode(searchParams.get("id")) 
   await axiosPrivate
      .get(`${link}/${id}`)
      .then((res) => {
        res.data.result.sort((a, b) => {
          return a.code.localeCompare(b.code, undefined, {
            numeric: true,
            sensitivity: 'base'
          });
        });
        if(filterValue==="enableData"){
          const filterDataResult=res.data.result.filter(fil=>fil.isActive)
          console.log(filterDataResult, "locationresult");
          setData(filterDataResult);
          setBackUpData(res.data.result)
        }else{
          setData(res.data.result)
          setBackUpData(res.data.result)
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "Remedy");
        setIsLoading(false);
        setData([])
        setBackUpData([])
      });
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  // const handleDelete = (id) => {
  //   const deleteLink = masterAPI["Remedies"].delete;
  //   axiosPrivate
  //     .delete(`${deleteLink}/${id}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       getData();
  //     })
  //     .catch((e) => {
  //       console.log(e, "delete causes");
  //     });
  // };

  const handleDelete = async(e,id,code) => {
    const enableLink = masterAPI["Remedies"].enable;
    const disableLink = masterAPI["Remedies"].disable;
    if(e.target.checked){
     await axiosPrivate
      .put(`${enableLink}/${id}/${code}`)
      .then((res) => {
        console.log(res.data);
        getData();
      })
      .catch((e) => {
        console.log(e, "enable ");
      });
    }else{
     await axiosPrivate
      .put(`${disableLink}/${id}/${code}`)
      .then((res) => {
        console.log(res.data);
        getData();
      })
      .catch((e) => {
        console.log(e, "disable ");
      });
    }
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: () => {
        return (
          <Box sx={{width:color.checkBoxWidth }}>
          <Checkbox
            // icon={<RadioButtonUncheckedOutlined />}
            // checkedIcon={<CheckCircle />}
          />
          </Box>
        );
      },
    },
    {
      Header: "Corrective Code",
      accessor: "code",
      // disableFilters: true,
      Cell: ({ cell }) => {
        return (
          <Link
            // to={`/masters/failureclass/problem/causes/remedy?id=${cell.row.original.id}`}
            style={{
              color: "#0d6efd",
              textDecorationLine: "underline",
              fontWeight: 800,
            }}
          >
            {cell.value}
          </Link>
        );
      },
    },
    {
      Header: "Corrective Name",
      accessor: "remedyName",
      // disableFilters: true,
    },
    {
      Header: "Cause Name",
      accessor: "causeName",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton disabled={!actionsAllow.edit}>
              <EditOutlined
                onClick={() => {
                  handleEdit(cell.row.original);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.edit? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton>
            {/* <IconButton disabled={!actionsAllow.delete}>
              <DeleteOutline
                onClick={() => {
                  handleDelete(cell.row.original.id);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.delete? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton> */}
            <Switch
            disabled={!actionsAllow.edit}
            checked={cell.row.original.isActive}
            onChange={(e)=>{handleDelete(e,cell.row.original.id,cell.row.original.code)}}
           
             />
          </Box>
        );
      },
    },
  ];
  const handleChangeFilter=(e)=>{
   
    if(e==="showAll"){
      setData(backUpData)
    }else{
        const filterDataResult=backUpData.filter(fil=>fil.isActive)
        
        setData(filterDataResult);
    }
    setFilterValue(e)   
  }

  return (
    <>
      <Box sx={{display:"flex",alignItems:"center"}}>
        <IconButton onClick={()=>{navigate(`/masters/failureClass/problem/causes?id=${encode(problemId)}`)}}>
          <ArrowBack/>
        </IconButton>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            // mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI["Remedies"].title}
        </Typography>
      </Box>
     
        <TableContainer
          columns={columns}
          data={data}
          buttonNew={handleButtonNew}
          loading={isLoading}
          display={"notVisible"}
          buttonDisable={!actionsAllow.edit}
          filterValue={filterValue}
          handleChange={handleChangeFilter}
          filterShow={true}
        />
   

      <ResponsiveDialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"md"}
        children={
          <RemedyModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
    </>
  );
};

export default Remedy;
